import { render, staticRenderFns } from "./DepositReceiptModal.vue?vue&type=template&id=3bb92003&scoped=true&"
import script from "./DepositReceiptModal.vue?vue&type=script&lang=js&"
export * from "./DepositReceiptModal.vue?vue&type=script&lang=js&"
import style0 from "./DepositReceiptModal.vue?vue&type=style&index=0&id=3bb92003&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb92003",
  null
  
)

export default component.exports